export { default } from './ManagerStatusHistory';
